import React from 'react';
import { UTLabel } from '@widergy/energy-ui';
import { func } from 'prop-types';

import UTSelectInput from 'app/components/UTSelectInput';
import { formOptionType, formsOptionsType, referenceType } from 'types/turnsTypes';
import { message } from 'utils/stringUtils';

import styles from './styles.module.scss';

const SelectForm = ({ currentForm, changeCurrentForm, options, refForms }) => (
  <div className={styles.container}>
    <span className={styles.anchor} ref={refForms} />
    <UTLabel semibold large className={styles.title}>
      {message('Turns:selectFormTitle')}
    </UTLabel>
    <div className={styles.select}>
      <UTSelectInput
        placeholder={message('Turns:selectFormPlaceHolder')}
        options={options}
        valueKey="value"
        labelKey="label"
        input={{
          onChange: changeCurrentForm
        }}
        meta={{}}
      />
    </div>
    {currentForm && currentForm.form_ov && (
      <div className={styles.cardContainer}>
        <UTLabel secondary className={styles.alertText}>
          {message('Turns:selectFormAlertInfo')}
        </UTLabel>
      </div>
    )}
  </div>
);

SelectForm.propTypes = {
  currentForm: formOptionType,
  changeCurrentForm: func,
  options: formsOptionsType,
  refForms: referenceType
};

export default SelectForm;
